export enum ContactServiceFileTypeSteps {
  CUSTOMER_DETAILS = "Customer Details",
  PURCHASE_DETAILS = "Purchase Details",
  // DAMAGE_DETAILS = "Damage Details",
  UPLOAD_DOCUMENTS = "Upload Documents",
  REVIEW_DETAILES = "Review Details",
}

export const ContactServiceSteps = [
  {
    step_num: 1,
    title: ContactServiceFileTypeSteps.CUSTOMER_DETAILS,
  },
  {
    step_num: 2,
    title: ContactServiceFileTypeSteps.PURCHASE_DETAILS,
  },
  // {
  //   step_num: 3,
  //   title: ContactServiceFileTypeSteps.DAMAGE_DETAILS,
  // },
  {
    step_num: 3,
    title: ContactServiceFileTypeSteps.UPLOAD_DOCUMENTS,
  },
  {
    step_num: 4,
    title: ContactServiceFileTypeSteps.REVIEW_DETAILES,
  },
];
